import { HttpErrorResponse, HttpRequest, HttpResponse } from '@angular/common/http';
import { AnalyticsServiceFactoryConfig } from '@rci/analytics-service';
import { APPLICATION_NAME } from '@rci/self-serve-fido/app.constant';
import { StateService } from '@rci/state-service';
import { AnalyticsService, PendingPayloadsSsrService } from '@rogers/analytics';
import { filter } from 'rxjs/operators';
import { AnalyticsStateService } from './analytics-state.service';

export const shouldTrackRoute = (url: string): boolean => {
  return !SUPPRESS_ROUTES_REGEX.test(url) || /manage-sim\/error/.test(url);
};

const SUPPRESS_ROUTES_LIST = [
  'wireless',
  'error',
  'change-phone-number',
  'transfer-phone-number',
  'change-caller-id',
  'change-voicemail-password',
];

const SUPPRESS_ROUTES_REGEX = new RegExp(SUPPRESS_ROUTES_LIST.join('|'));

export function analyticsServiceFactory(
  _config: AnalyticsServiceFactoryConfig,
  stateService: StateService,
  analyticsStateService: AnalyticsStateService,
  pendingPayloadsSsrService: PendingPayloadsSsrService,
  PLATFORM_ID: Object,
) {
  const pageMap = {
    '': 'home',
    '/': 'home',
  };
  const modalFunc = () => {
    return '';
  };
  const siteName = 'F';

  const analyticsService = new AnalyticsService(
    {
      personalization: analyticsStateService.personalization$,
      language: stateService.language$,
      province: stateService.province$,
      account: analyticsStateService.account$,
      page: analyticsStateService.page$.pipe(filter(url => shouldTrackRoute(url.toString()))),
    },
    siteName,
    pageMap,
    pendingPayloadsSsrService,
    APPLICATION_NAME,
    modalFunc,
    PLATFORM_ID,
  );
  analyticsService.interceptorConfigs = [
    {
      shouldInterceptRequest: (_req: HttpRequest<any>) => {
        return false;
      },

      shouldInterceptResponse: (_req: HttpRequest<any>, _resp: HttpResponse<any>) => {
        return false;
      },

      requestInterceptor: (_req: HttpRequest<any>) => {},

      responseInterceptor: (_req: HttpRequest<any>, _resp: HttpResponse<any>) => {},

      // should this error be handled?
      shouldHandleError: (_req: HttpRequest<any>, _err: HttpErrorResponse) => {
        return false;
      },

      // log an error beacon when above shouldHandleError is true
      errorHandler: (_req: HttpRequest<any>, _err: HttpErrorResponse) => {},
    },
  ];
  return analyticsService;
}

export const AnalyticsServiceWrapper = (analyticsService: AnalyticsService) => {
  return analyticsService;
};
